// extracted by mini-css-extract-plugin
module.exports = {"slideOverlay":"HeroSlide_slideOverlay__2n1ZR"};